var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-boolean"},[_c('BaseSwitcher',{attrs:{"label":_vm.field.label,"value":_vm.valueParsed,"trueLabel":_vm.subFormData.onVal,"falseLabel":_vm.subFormData.offVal,"hint":_vm.hint},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7475d902","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditBoolean.vue
// module id = 612
// module chunks = 0